<template>
      <router-view></router-view>
</template>

<script>
export default {
    name: 'VipPoint',
    components: {
    },
    created() {
    },
    mounted() {
    },
    updated() {
    },
    data(){
        return {
        }
    },
    methods: {
    }
}
</script>